import { rootComponentRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { UpdateRootComponentRequest } from "./update-root-component/UpdateRootComponentRequest";
import { UpdateRootComponentResponse } from "./update-root-component/UpdateRootComponentResponse";
import { CreateRootComponentRequest } from "../root-component/create-root-component/CreateRootComponentRequest";
import { CreateRootComponentResponse } from "../root-component/create-root-component/CreateRootComponentResponse";

export const useUpdateRootComponent = () =>
  useRestResourceHook<UpdateRootComponentRequest, UpdateRootComponentResponse>(
    (request) => rootComponentRestResource.updateRootComponent(request),
  );

export const useCreateRootComponent = () =>
  useRestResourceHook<CreateRootComponentRequest, CreateRootComponentResponse>(
    (request) => rootComponentRestResource.createRootComponent(request),
  );
